(() => {
  const row = document.querySelector('[data-fabric-profile]');
  if (!row) return;
  const target = row.querySelector('[data-fabric-fact]');
  const profile = row.dataset.fabricProfile || '';
  const items = Array.from(row.querySelector('template')?.content.querySelectorAll('li,p') || []).map(el => el.textContent.trim());
  const description = items.find(text => /\d+\s*%/.test(text) && /cotton|polyester|viscose|rayon|linen|spandex/i.test(text)) || '';
  const source = /\d+\s*%/.test(profile) ? profile : description;
  const polyester = source.match(/(\d+(?:\.\d+)?)\s*%\s*polyester/i) || source.match(/polyester\s*[:(]?\s*(\d+(?:\.\d+)?)\s*%/i);
  const heavyBlend = (polyester && Number(polyester[1]) >= 40) || /50\s*[/–-]\s*50.*polyester/i.test(source);
  const intro = document.querySelector('#pdp-section .pdp-intro');
  const normalize = value => value.toLowerCase().replace(/[.;]$/, '').replace(/\s+/g, ' ').trim();
  if (intro && source && normalize(intro.textContent) === normalize(source)) intro.hidden = true;
  const update = () => {
    const color = document.querySelector('#product-form [data-option-role="color"].is-selected')?.dataset.optionValue || '';
    const uncertainBlend = /heather|sport\s*gr[ae]y|ash|tweed/i.test(color) && /100\s*%\s*cotton/i.test(source);
    target.hidden = !source || heavyBlend || uncertainBlend || source.length > 85;
    target.textContent = target.hidden ? '' : source.replace(/[.;]$/, '');
  };
  document.getElementById('product-form')?.addEventListener('click', () => queueMicrotask(update));
  update();
})();
